import { createApiClient } from '@volee/api-client'
import { idTokenProvider } from '@volee/auth'

import { auth } from './auth.ts'

/*
 * The app's API client.
 *
 * Tokens are injected rather than imported: @volee/api-client asks for it that way, so the
 * two packages stay uncoupled (see api-client's README). This is the point where they meet.
 *
 * `baseUrl` is not passed: the default is `API_BASE_URL` from @volee/config, which stays the
 * source of truth. The back-office talks to the same API as the public app — there is no
 * separate administrative backend.
 *
 * `onSessionExpired` does not navigate from here: the router does not exist yet when this
 * module is evaluated, so the reaction is registered by router.tsx (see `onSessionLost`).
 */
let onSessionExpired: () => void = () => {}

/** Registers what to do when the session is unrecoverable. The router calls it. */
export function onSessionLost(reaction: () => void): void {
  onSessionExpired = reaction
}

/** Runs the registered reaction. Exported as the test seam: nothing else can trigger it. */
export function notifySessionExpired(): void {
  onSessionExpired()
}

export const api = createApiClient({
  tokens: {
    // The Bearer credential is the id_token, not the OAuth access token — the whole
    // story is on idTokenProvider, in @volee/auth.
    ...idTokenProvider(auth),
    onSessionExpired: notifySessionExpired,
  },
})
